import { Reducer } from 'redux';

import { DashboardSettingsActionTypes, DashboardSettingsState } from './types';

const defaultState: DashboardSettingsState = {
    dashboardSettingsLoading: false,
    dashboardSettingsList: null,
    setDefaultEditorLoading: false,
};
const reducer: Reducer<DashboardSettingsState> = (state: DashboardSettingsState = defaultState, action): DashboardSettingsState => {
    const { payload } = action;

    switch (action.type) {
        case DashboardSettingsActionTypes.GET_DASHBOARD_SETTINGS:
            return { ...state, ...{ dashboardSettingsLoading: true }};
        case DashboardSettingsActionTypes.GET_DASHBOARD_SETTINGS_ERROR:
            return { ...state, ...{ dashboardSettingsLoading: false }};
        case DashboardSettingsActionTypes.GET_DASHBOARD_SETTINGS_SUCCESS:
            return { ...state, ...{ dashboardSettingsLoading: false, dashboardSettingsList: payload.dashboardSettingsList }};
        case DashboardSettingsActionTypes.SET_DEFAULT_EDITOR:
            return { ...state, ...{ setDefaultEditorLoading: true }};
        case DashboardSettingsActionTypes.SET_DEFAULT_EDITOR_ERROR:
        case DashboardSettingsActionTypes.SET_DEFAULT_EDITOR_SUCCESS:
            return { ...state, ...{ setDefaultEditorLoading: false }};
        default:
            return state;
    }
};

export { reducer as dashboardSettings };

export default reducer;
